module.exports = new __parcel__URL__("benefits_5.4ba1148a.webp").toString();